import React, { useState } from 'react';
import { Modal, Input, Select, Button } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import styles from './add-user-modal.module.scss';

export const AddUserModal = ({ visible, onClose }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    role: 'team_member',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleRoleChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      role: value,
    }));
  };

  const handleSubmit = () => {
    // Here you would typically send the data to your API
    console.log('Submitting user data:', formData);

    // Reset form and close modal
    setFormData({
      firstName: '',
      lastName: '',
      email: '',
      role: 'team_member',
    });
    onClose();
  };

  const roleOptions = [
    { value: 'admin', label: 'Administrator' },
    { value: 'team_member', label: 'Team Member' },
  ];

  return (
    <Modal
      title={null}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={600}
      centered
      closeIcon={<span style={{ fontSize: '24px' }}>&times;</span>}>
      <div className={styles.modalTitle}>Add New User</div>

      <div className={styles.formRow}>
        <div className={styles.formGroup}>
          <label className={styles.formLabel}>First Name</label>
          <Input
            className={styles.formInput}
            placeholder="Enter first name"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            size="large"
          />
        </div>

        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Last Name</label>
          <Input
            className={styles.formInput}
            placeholder="Enter last name"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            size="large"
          />
        </div>
      </div>

      <div className={styles.formGroup}>
        <label className={styles.formLabel}>Email</label>
        <Input
          className={styles.formInput}
          placeholder="Enter user's email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          size="large"
        />
      </div>

      <div className={styles.formGroup}>
        <label className={styles.formLabel}>Role</label>
        <Select
          className={styles.formSelect}
          placeholder="Select role"
          value={formData.role}
          onChange={handleRoleChange}
          options={roleOptions}
          suffixIcon={<DownOutlined className="text-dark-blue-50" />}
          size="large"
          style={{ height: '48px' }}
        />
      </div>

      <div className={styles.modalFooter}>
        <Button className={styles.cancelButton} onClick={onClose} size="large">
          Cancel
        </Button>
        <Button className={styles.submitButton} onClick={handleSubmit} size="large" type="primary">
          Add User
        </Button>
      </div>
    </Modal>
  );
};
